import React from 'react';
import { HashRouter as Router } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import ScrollToTop from "./pages/ScrollToTop";
import { ToastContainerComponent } from './config/Alert';
import AppRouter from './App.router';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const App = () => {

  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <ToastContainerComponent />
        <AppRouter />
      </Router>
    </CartProvider>
  );
}

export default App;
